import { useEffect } from 'react';

export const useAnimationLoop = ({
    isPlaying,
    isSliderVisible,
    sliderValue,
    dateSelected,
    variableSelected,
    updateCMIPImmediate,
    isMapLoading,
    isLoadTimedOut,
    animationSpeed
}) => {
    useEffect(() => {
        let timeoutId = null;
        // Only set a timeout if the animation is playing and a map is loading
        if (isPlaying && isSliderVisible && dateSelected && dateSelected.length > 1) {
            // Advance to the next frame if the map is NOT currently loading OR if it has timed out
            if (!isMapLoading || isLoadTimedOut) {
                timeoutId = setTimeout(() => {
                    const maxValue = dateSelected.length - 1;
                    const nextValue = sliderValue + 1 > maxValue ? 0 : sliderValue + 1;
                    updateCMIPImmediate(nextValue, variableSelected);
                }, animationSpeed); // Wait based on animationSpeed AFTER the map loads/times out before advancing
            }
        }
        return () => clearTimeout(timeoutId);
    }, [isPlaying, isSliderVisible, sliderValue, dateSelected, variableSelected, updateCMIPImmediate, isMapLoading, isLoadTimedOut, animationSpeed]);
};
